exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".my-label-text-size .v-label{font-size:14px!important}img{float:right}", "", {"version":3,"sources":["/app/src/components/Incidents.vue"],"names":[],"mappings":"AACA,6BACE,wBAA2B,CAC5B,AACD,IACE,WAAa,CACd","file":"Incidents.vue","sourcesContent":["\n.my-label-text-size .v-label {\n  font-size: 14px !important;\n}\nimg {\n  float: right;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":{"safe":true,"reduceIdents":false,"zindex":false,"mergeRules":false,"discardComments":{"removeAll":true}},"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05ade38f","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Incidents.vue
// module id = 869
// module chunks = 7